import { Text, Image } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { localyticsEvent } from '../../../lib/utils';
import { ANALYTICS_EVENTS } from '../../constants';
import styles from './AppBadges.module.css';
import ReviewStats from './ReviewStats';


const cx = classnames.bind(styles);

export default function AppBadges({ analyticsScreenName, className, fluid, showReviewSections }) {
  const handleAppStoreClick = useCallback(() => {
    localyticsEvent(ANALYTICS_EVENTS.APP_STORE_LINK_CLICK, { Store: 'iTunes', 'Screen Name': analyticsScreenName });
  }, [analyticsScreenName]);

  const handlePlayStoreClick = useCallback(() => {
    localyticsEvent(ANALYTICS_EVENTS.APP_STORE_LINK_CLICK, { Store: 'PlayStore', 'Screen Name': analyticsScreenName });
  }, [analyticsScreenName]);

  return (
    <div className={cx('imageGroupContainer', { fluid }, className)}>
      <Text as="a" color="grey" href="https://apps.apple.com/us/app/gasbuddy-find-cheap-gas-prices/id406719683?mt=8" target="_blank" rel="noopener noreferrer">
        <Image
          lazy
          alt="Apple Store Badge Button"
          src="https://static.gasbuddy.com/web/apple-store-badge.png"
          srcSet="https://static.gasbuddy.com/web/apple-store-badge.png 1x, https://static.gasbuddy.com/web/apple-store-badge@2x.png 2x"
          title="Apple Store Badge Button"
          onClick={handleAppStoreClick}
        />
        {
          showReviewSections && <ReviewStats name="iOSAppRating" rating={4.5} reviewCount="380,000+" />
        }
      </Text>
      <Text as="a" color="grey" href="https://play.google.com/store/apps/details?id=gbis.gbandroid" target="_blank" rel="noopener noreferrer">
        <Image
          lazy
          alt="Google Play Store Badge Button"
          src="https://static.gasbuddy.com/web/play-store-badge.png"
          srcSet="https://static.gasbuddy.com/web/play-store-badge.png 1x, https://static.gasbuddy.com/web/play-store-badge@2x.png 2x"
          title="Google Play Store Badge Button"
          onClick={handlePlayStoreClick}
        />
        {
          showReviewSections && <ReviewStats name="androidAppRating" rating={4.5} reviewCount="770,000+" />
        }
      </Text>
    </div>
  );
}

AppBadges.propTypes = {
  analyticsScreenName: PropTypes.string.isRequired, // TODO: consider using useContext to set this value
  className: PropTypes.string,
  fluid: PropTypes.bool,
  showReviewSections: PropTypes.bool,
};

AppBadges.defaultProps = {
  className: undefined,
  fluid: true,
  showReviewSections: false,
};
